import BrandsIndex from "src/modules/brands/components/BrandsIndex";
import { InstantSearch } from "react-instantsearch-hooks-web";
import { useState } from "react";
import useCreateAlgoliaClient from "src/hooks/algolia/useCreateAlgoliaClient";
import useAlgoliaIndex from "src/hooks/algolia/useAlgoliaIndex";
import { InstantSearchStatus } from "instantsearch.js/es/lib/InstantSearch";
import { BrandInfoModal } from "src/molecules/BrandInfoModal";

interface AlgoliaBrandInfoProps {
  open: boolean;
  onClose: () => void;
  genderId: string;
  brandSlug: string;
}

const AlgoliaBrandInfo = ({
  open,
  onClose,
  genderId,
  brandSlug,
}: AlgoliaBrandInfoProps): JSX.Element | null => {
  const { client } = useCreateAlgoliaClient();
  const algoliaIndex = useAlgoliaIndex({
    indexName: "brands",
  });
  const [status, setStatus] = useState<InstantSearchStatus>("idle");
  const loading = status === "loading" || status === "stalled";

  return (
    client && (
      <InstantSearch searchClient={client} indexName={algoliaIndex}>
        <BrandsIndex
          genderId={genderId}
          brandSlug={brandSlug}
          onStatusChanged={setStatus}
        >
          {brandSlug && genderId && (
            <BrandInfoModal
              open={open}
              loading={loading}
              onClose={onClose}
              pageType="pdp"
            />
          )}
        </BrandsIndex>
      </InstantSearch>
    )
  );
};

export default AlgoliaBrandInfo;
